import { InputValidationErrorType, SCError } from "@next-platform/packages-ts-types";
import { useTranslation } from "../localization/hooks";
const { ERROR_CODE_PREFIX } = SCError || {};
// eslint-disable-next-line id-length -- matches useTranslation().t; literal t("error:inputValidation.…") keys for grep / i18n extractors
function getInputValidationErrorMessage(t) {
    return {
        [`${ERROR_CODE_PREFIX}-${InputValidationErrorType.INVALID_CONFIGURATION}`]: t("error:inputValidation.invalidConfiguration"),
        [`${ERROR_CODE_PREFIX}-${InputValidationErrorType.INVALID_MODERATION_ACTION}`]: t("error:inputValidation.invalidModerationAction"),
        [`${ERROR_CODE_PREFIX}-${InputValidationErrorType.INVALID_PAYLOAD}`]: t("error:inputValidation.invalidPayload"),
        [`${ERROR_CODE_PREFIX}-${InputValidationErrorType.INVALID_REQUEST}`]: t("error:inputValidation.invalidRequest"),
        [`${ERROR_CODE_PREFIX}-${InputValidationErrorType.UNKNOWN_PARAMETERS}`]: t("error:inputValidation.unknownParameters"),
    };
}
// eslint-disable-next-line import/prefer-default-export -- named hook export matches package barrel
export function useInputValidationErrors() {
    const { t } = useTranslation();
    const nonContextInputValidationErrors = getInputValidationErrorMessage(t);
    const getMessage = ({ errorCode, fallbackMessage, skipDefaultMessage }) => {
        const nonContextError = nonContextInputValidationErrors[errorCode];
        if (nonContextError) {
            return nonContextError;
        }
        if (skipDefaultMessage)
            return "";
        return fallbackMessage || t("error:fallbackError");
    };
    return {
        getMessage,
    };
}
